import { UserSearch } from 'lucide-react';
import BaseNode from '../BaseNode';
import { CATEGORY_COLORS } from '../../../constants';

export default function GetMemberNode({ id, data, selected }) {
  const summary = data.filterField && data.filterValue
    ? `${data.filterField}: ${data.filterValue}`
    : null;

  return (
    <BaseNode
      id={id}
      selected={selected}
      color={CATEGORY_COLORS.wallettwo}
      icon={UserSearch}
      label={data.label}
    >
      <p className="text-xs text-gray-500">{summary || data.description}</p>
    </BaseNode>
  );
}
